<template>
  <v-dialog v-model="showAddQuote" width="1200" persistent>
    <v-card>
      <div id="queryHolder"></div>

      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">Add an Quote</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <p class="white--text"></p>
          </v-col>
        </v-row>
      </v-banner>

      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text class="pt-0">
          <v-divider class="mt-4 mb-8"></v-divider>
          <quote-form
            ref="quoteForm"
            :is-editing="false"
            :query="{}"
            @close="closeQuery"
          ></quote-form>
        </v-card-text>
        <div class="text-right fixed-bar rtl primary py-4">
          <v-btn @click="closeQuery()" class="mr-4">Close</v-btn>
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import QuoteForm from "@/components/quoteManagement/quote-form";
export default {
  name: "add-quote",
  components: {QuoteForm},
  props: {
    showAddQuote: { type: Boolean, required: true },
  },
  methods:{
    showSlotsResultSection(details) {
      let vm = this;
      // vm.$refs.queryAvailableSlotsResultsNbn.showSlotsResult = true;
      // vm.$refs.queryAvailableSlotsResultsNbn.result = details;
    },
    closeQuery() {
      let vm = this;
      document.getElementById("queryHolder").scrollIntoView({behavior: "smooth"});
      vm.$refs.observer.reset();
      vm.$emit("closeQuery");
    },
  }
}
</script>

<style scoped>

</style>
